"use strict";
/**
 * ErrorIdGenerator - UUID v5 deterministic ErrorId generation
 * Same error type + message + context = same ErrorId (idempotence)
 * Different error type or context = different ErrorId (uniqueness)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorIdGenerator = void 0;
const uuid_1 = require("uuid");
/**
 * Fixed namespace UUID for Ledgiventa errors
 * Used as base for all v5 generation
 */
const NAMESPACE_UUID = '550e8400-e29b-41d4-a716-446655440000';
/**
 * ErrorIdGenerator - Utility class for deterministic error ID generation
 */
class ErrorIdGenerator {
    /**
     * Generate a deterministic ErrorId using UUID v5
     * Same inputs always produce same ErrorId (idempotent)
     */
    static generate(options) {
        const { errorType, message, context = {} } = options;
        // Create a deterministic name by combining error type, message, and context
        // Sort object keys to ensure consistent ordering
        const contextString = JSON.stringify(context, Object.keys(context).sort());
        const name = `${errorType}:${message}:${contextString}`;
        // Generate UUID v5 using the Ledgiventa namespace
        return (0, uuid_1.v5)(name, NAMESPACE_UUID);
    }
}
exports.ErrorIdGenerator = ErrorIdGenerator;
